import { useEffect, useState } from 'react';
import styled from '@emotion/styled';

import { useCatalogProductIdParams } from '@domains/pdp-common';

import { ProductSwatchItem } from '../components/ProductSwatchCard';
import { ProductSwatchCarousel } from '../components/ProductSwatchCarousel';
import { ProductSwatchCarouselSkeleton } from '../components/ProductSwatchCarouselSkeleton';
import { useProductSwatchCarouselUBL } from '../log/useProductSwatchCarouselUBL';
import { useProductSwatchCarouselService } from '../services/useProductSwatchCarouselService';

const MIN_ITEMS_FOR_RENDER = 2;

export const ProductSwatchCarouselContainer = () => {
  const { catalog_product_id: catalogProductId } = useCatalogProductIdParams();
  const { items, loading, goToAnotherProductDetailPage } = useProductSwatchCarouselService(catalogProductId);
  const { colorSwatchImpressionUBL, colorSwatchClickUBL } = useProductSwatchCarouselUBL();

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  if (loading === false && items.length < MIN_ITEMS_FOR_RENDER) {
    return null;
  }

  const sendColorSwatchImpressionUBL = (item: ProductSwatchItem, position: number) => {
    colorSwatchImpressionUBL({
      catalog_product_id: item.id,
      item_idx: position,
      original_product_id: catalogProductId,
    });
  };

  const sendColorSwatchClickUBL = (item: ProductSwatchItem, position: number) => {
    colorSwatchClickUBL({
      catalog_product_id: item.id,
      item_idx: position,
      original_product_id: catalogProductId,
    });
  };

  const handleItemClick = (item: ProductSwatchItem, position: number) => {
    sendColorSwatchClickUBL(item, position);
    goToAnotherProductDetailPage(item);
  };

  return (
    <Container>
      {loading ? (
        <ProductSwatchCarouselSkeleton />
      ) : (
        <ProductSwatchCarousel
          items={items}
          onItemClick={handleItemClick}
          onItemImpression={sendColorSwatchImpressionUBL}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  margin: 14px 0 -10px;
`;
